module.exports = __webpack_public_path__ + "static/img/20.0ab6beb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/zh/20.png
// module id = ETSU
// module chunks = 0